<template>
    <ul class="list-unstyled">
        <li v-for="file in files" style="margin-bottom: 12px;">
            <template v-if="can_view(file)">
                <a :href="`/files/view/${file.id}`" target="_blank" v-if="can_view_in_browser(file.file_ext)">
                    {{ file.file_title ? file.file_title + (file.file_ext ? '.'+file.file_ext : '') : file.file_name }}
                </a>
                <a :href="`/files/download/${file.id}`" target="_blank" v-else>
                    {{ file.file_title ? file.file_title + (file.file_ext ? '.'+file.file_ext : '') : file.file_name }}
                </a>
            </template>
            <span v-else>{{ file.file_title ? file.file_title + (file.file_ext ? '.'+file.file_ext : '') : file.file_name }}</span>

            <div class="text-muted">
                {{ file.created_at | moment('timezone', timezone, "MM/DD/YYYY hh:mm a") }} <span v-if="file.first_name">by {{ file.first_name }} {{ file.last_name }}</span>

                <span v-if="file.is_sensitive == 1" class="badge badge-warning">SENSITIVE</span>
            </div>
            <div>
                <template v-if="can_view(file)">
                    <span v-if="can_view_in_browser(file.file_ext)">
                        <a :href="`/files/view/${file.id}`" target="_blank" title="View File in a New Tab">View</a> |&nbsp;
                    </span>
                    <a :href="`/files/download/${file.id}`" target="_blank">Download</a>
                </template>
                <span v-if="can_edit(file)">
                    | <router-link :to="'/files/edit/'+file.id">Edit</router-link> |
                    <router-link :to="'/files/delete/'+file.id" class="text-danger">Delete</router-link>
                </span>
            </div>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            files: {
                type: Array,
                required: true,
            },

            colClass: {
                type: String,
                default: null,
            },

            actionBtns: {
                type: Boolean,
                default: true,
            }
        },

        data() {
            return {
                timezone: this.$root.timezone,
            }
        },

        computed: {

        },

        methods: {
            can_view_in_browser(file_ext){
                //Setup
                var can_view_exts = [
                    'jpg',
                    'jpeg',
                    'png',
                    'gif',
                    'tiff',
                    'pdf',
                ];

                //Send it
                return can_view_exts.includes(file_ext);
            },

            can_view(file){
                //Set
                return file.is_sensitive == 0 || this.$root.hasPermission(this.$root.getRecordPlural(file.record_type)+'.view.sensitive')
            },

            can_edit(file){
                //Setup Table
                var table = this.$root.getRecordPlural(file.record_type);

                //Check if they can manage and either the file is not sensitive or the user has sensitive permissions
                if( this.$root.hasPermission(table+'.manage') && (file.is_sensitive == 0 || this.$root.hasPermission(table+'.view.sensitive')) )
                {
                    return true;
                }

                //Send true for now, need to check permissiosn and type
                return false;
            },
        },

        mounted() {

        }
    }
</script>

<style type="text/css" scope>
    .img-fluid {
        border: 1px solid #ccc;
    }
</style>
